import {Input} from '../ui';
import {
  CheckboxField,
  CleaningStatus,
  ConditionCode,
  ImageField,
  InputField,
  MicrolabTestResult,
  NumericField,
  RadioField,
  SelectField,
  SumpSample,
  SumpSampleNA,
  TankCondition,
  TextField,
} from '../fields';
import {useDispatch, useSelector} from 'react-redux';
import {setActiveField, setDrag} from '../service/createForm.slice';
import {useDragAndDrop} from './useDragAndDrop';
import {useLocation} from 'react-router-dom';

const chooseField = (type, field, idx) => {
  switch (type) {
    case 'text':
      return <InputField field={field} idx={idx} />;
    case 'radio':
      return <RadioField field={field} idx={idx} />;
    case 'condition_code':
      return <ConditionCode field={field} idx={idx} />;
    case 'numeric':
      return <NumericField field={field} idx={idx} />;
    // case 'checkbox':
    // 	return <CheckboxField field={field} idx={idx}/>
    case 'multiple_photo':
      return <ImageField field={field} idx={idx} />;
    // case 'textarea':
    // 	return <TextField field={field} idx={idx}/>
    case 'select':
      return <SelectField field={field} idx={idx} />;
    case 'sump_sample':
      return <SumpSample field={field} idx={idx} />;
    case 'sump_sample_optional':
      return <SumpSampleNA field={field} idx={idx} />;
    case 'tank_condition':
      return <RadioField field={field} idx={idx} />;
    case 'cleaning_status':
      return <RadioField field={field} idx={idx} />;
    case 'microlab_test_result':
      return <RadioField field={field} idx={idx} />;
    default:
      return <div></div>;
  }
};

export const useRenderFields = () => {
  const dispatch = useDispatch();

  const fields = useSelector(
    state => state.rootReducer.createFormSlice.data.fields,
  );
  const active_field_idx = useSelector(
    state => state.rootReducer.createFormSlice.active_field,
  );

  const dragAndDrop = useDragAndDrop();

  const handleActiveField = idx => {
    dispatch(setActiveField({idx}));
  };

  const render = () => {
    return fields?.map((field, idx) => {
      return (
        <div
          className={`f-build__field`}
          key={idx}
          draggable
          onDragStart={e => dragAndDrop.handleDragStart(e, field.id)}
          onDragOver={e => dragAndDrop.handleDragOver(e, field.id)}
          onDragEnd={dragAndDrop.handleDragEnd}
        >
          <div className='f-build__field-index'>{idx + 1} Field</div>
          <div
            className={`f-build__field-component ${active_field_idx === idx ? 'active' : ''}`}
            onClick={() => handleActiveField(idx)}
          >
            <div className='f-build__drag'></div>
            {chooseField(field?.field_type, field, idx)}
          </div>
        </div>
      );
    });
  };

  return {
    render,
  };
};
